<div class="container-fluid" style="max-width: 1200px;">
    <h1 class="m-3 display-6 vm-container-header">Trading Partners</h1>

    <div class="pb-5">
        <div class="m-3 p-2 bg-body-light rounded-3 shadow">
            <div class="m-2">
                <form>
                    <div class="mb-3 row align-items-center">
                        <div class="col-sm-auto">
                            <select (change)="this.onCustomerChange($event)" aria-label="Select a customer" class="form-select">
                                <option selected>Select a Customer</option>
                                @for (entity of this.customers; track entity.id; ) {
                                    <option value="{{ entity.id }}">{{ entity.name }}</option>
                                }
                            </select>
                        </div>

                        <app-table-search [(value)]="this.service.searchTerm" />
                    </div>
                </form>

                @if (!!this.customerId && ((this.total$ | async) ?? 0) > 0) {
                    <table class="table table-striped table-hover">
                        <caption>{{ this.total$ | async }} Total</caption>

                        <thead>
                        <tr>
                            <th (sort)="this.onSort($event)" scope="col" sortable="name">Name</th>
                            <th (sort)="this.onSort($event)" scope="col" sortable="groupName">Group Name</th>
                            <th scope="col">Address</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>

                        <tbody class="table-group-divider">
                            @for (element of this.service.data$ | async; track element.id; ) {
                                <tr>
                                    <td class="align-middle">{{ element.name }}</td>
                                    <td class="align-middle">{{ element.groupName }}</td>
                                    <td class="align-middle text-ellipsis" title="{{ getAddress(element) }}" style="max-width: 20em;">
                                        {{ getAddress(element) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <div class="btn-group" role="group">
                                            <i class="btn btn-sm btn-outline-primary bi bi-pencil" (click)="onEdit(element)"></i>
                                            <a class="btn btn-sm btn-outline-primary bi bi-building-down" routerLink="/master-data/distribution-centers"
                                               [queryParams]="{customerId: this.customerId, tradingPartnerId: element.id}" title="Distribution Centers" aria-label="Distribution Centers"></a>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }

                @if (!!this.customerId && ((this.total$ | async) ?? 0) > 0) {
                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (!this.customerId) {
                    <div class="card text-center bg-info-subtle border border-info rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-info-circle-fill me-2"></i>Select a customer to see its Trading Partners.
                        </div>
                    </div>
                }

                @if (!!this.customerId && ((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No trading partners found.
                        </div>
                    </div>
                }
            </div>
        </div>


        <ng-template #editModal>
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="editModalLabel">
                    Edit Trading Partner
                </h1>
                <button (click)="onEditDismiss()" type="button" class="btn-close" aria-label="Close"></button>
            </div>

            <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
                <div class="modal-body container-fluid">
                    <div class="row g-0">
                        <div class="form-floating col-md-12">
                            <input type="text" class="form-control" id="nameControl" formControlName="name">
                            <label for="nameControl" class="form-label">Name</label>

                            @if (controls.name.invalid && (controls.name.dirty || controls.name.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.name.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>

                        <div class="form-floating col-md-6 mt-3 vm-pe-1">
                            <input type="text" class="form-control" id="abbreviationControl" formControlName="abbreviation">
                            <label for="abbreviationControl" class="form-label">Abbreviation</label>

                            @if (controls.abbreviation.invalid && (controls.abbreviation.dirty || controls.abbreviation.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.abbreviation.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>

                        <div class="form-floating col-md-6 mt-3">
                            <input type="text" class="form-control" id="groupNameControl" formControlName="groupName">
                            <label for="groupNameControl" class="form-label">Group Name</label>
                        </div>

                        <div class="form-floating col-md-12 mt-3">
                            <input type="text" class="form-control" id="address1Control" formControlName="address1">
                            <label for="address1Control" class="form-label">Address 1</label>

                            @if (controls.address1.invalid && (controls.address1.dirty || controls.address1.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.address1.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>

                        <div class="form-floating col-md-12 mt-3">
                            <input type="text" class="form-control" id="address2Control" formControlName="address2">
                            <label for="address2Control" class="form-label">Address 2</label>

                            @if (controls.address2.invalid && (controls.address2.dirty || controls.address2.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.address2.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>

                        <div class="form-floating col-md-5 mt-3 vm-pe-1">
                            <input type="text" class="form-control" id="cityControl" formControlName="city">
                            <label for="cityControl" class="form-label">City</label>

                            @if (controls.city.invalid && (controls.city.dirty || controls.city.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.city.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>

                        <div class="form-floating col-md-4 mt-3 vm-pe-1">
                            <select class="form-select" id="state" formControlName="state" required>
                                <option selected disabled value="">Choose...</option>
                                @for (state of this.globalService.stateList; track state.abbreviation) {
                                    <option [ngValue]="state.abbreviation" [selected]="state.abbreviation == this.editForm.value.state">{{ state.name }}</option>
                                }
                            </select>
                            <label for="state" class="form-label">State</label>
                        </div>

                        <div class="form-floating col-md-3 mt-3">
                            <input type="text" class="form-control" id="zipCodeControl" formControlName="zipCode" required>
                            <label for="zipCodeControl" class="form-label">Zip Code</label>

                            @if (controls.zipCode.invalid && (controls.zipCode.dirty || controls.zipCode.touched)) {
                                <div class="alert alert-danger">
                                    @if (controls.zipCode.hasError('required')) {
                                        <div>Required</div>
                                    }
                                </div>
                            }
                        </div>
                    </div>

                    <div class="row g-0 mt-4">
                        <h5>
                            File Expectations
                            <i class="bi bi-info-circle" title="# of ST segments for a day of week & file type"></i>
                        </h5>
                        <div formArrayName="tradingPartnerFileExpectations">
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th class="col col-3">File Type</th>
                                            <th>Day of Week</th>
                                            <th class="col col-3">File Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (fileExpectation of fileExpectationForm; track $index) {
                                            <tr [formGroupName]="$index">
                                                <td>
                                                    <input type="text" class="form-control-plaintext form-control-sm" [formControl]="fileExpectation.controls.type">
                                                </td>
                                                <td>{{ DaysOfWeek[fileExpectation.controls.dayOfWeek.value] }}</td>
                                                <td>
                                                    <input type="number" class="form-control form-control-sm" [formControl]="fileExpectation.controls.fileCount">
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button [disabled]="savingData" type="submit" class="btn btn-primary">
                        @if (savingData) {
                            <span class="spinner-border spinner-border-sm me-1"></span>
                        }
                        Save
                    </button>
                    <button (click)="onEditDismiss()" type="button" class="btn btn-secondary">Close</button>
                </div>
            </form>
        </ng-template>

        <app-modal-confirm #confirmationModal></app-modal-confirm>
    </div>
</div>
